'use client';

import { Box, Container, Typography, Grid, Paper, Chip } from '@mui/material';
import { dronesData } from '@/data/proyectos/drones/dronesData';

export default function CapabilitiesSection() {
  return (
    <Box sx={{ py: 10, bgcolor: '#f8fafc' }}>
      <Container maxWidth="lg">
        <Box textAlign="center" mb={8}>
          <Chip 
            label="CAPACIDADES TÉCNICAS" 
            sx={{ 
              bgcolor: 'rgba(0, 150, 255, 0.1)', 
              color: '#0066cc',
              fontWeight: 600,
              mb: 2,
              px: 2
            }}
          />
          <Typography variant="h3" fontWeight={700} mb={2}>
            Tecnologías de Adquisición de Datos
          </Typography>
          <Typography variant="h6" color="text.secondary" maxWidth="800px" mx="auto">
            Plataformas y sensores especializados para investigación científica
          </Typography>
        </Box>

        <Grid container spacing={4}>
          {dronesData.capabilities.map((capability) => (
            <Grid key={capability.id} item xs={12} md={6} lg={3}>
              <Paper
                elevation={0}
                sx={{
                  height: '100%',
                  p: 4,
                  borderRadius: 3,
                  bgcolor: 'white',
                  border: '1px solid #e2e8f0',
                  transition: 'all 0.3s ease',
                  '&:hover': {
                    transform: 'translateY(-8px)',
                    boxShadow: '0 20px 40px rgba(0, 102, 204, 0.1)',
                    borderColor: '#0066cc'
                  }
                }}
              >
                <Box sx={{ fontSize: '3rem', mb: 2 }}>{capability.icon}</Box>
                
                <Typography variant="h5" fontWeight={600} mb={2}>
                  {capability.title}
                </Typography>
                
                <Typography variant="body1" color="text.secondary" mb={3}>
                  {capability.description}
                </Typography>
                
                <Box mb={3}>
                  <Typography variant="subtitle2" fontWeight={600} mb={1}>
                    Aplicaciones:
                  </Typography>
                  {capability.applications.map((app, idx) => (
                    <Chip
                      key={idx}
                      label={app}
                      size="small"
                      sx={{
                        mr: 1,
                        mb: 1,
                        bgcolor: 'rgba(0, 102, 204, 0.1)',
                        color: '#0066cc'
                      }}
                    />
                  ))}
                </Box>
                
                <Box sx={{ pt: 2, borderTop: '1px solid #e2e8f0' }}>
                  {Object.entries(capability.metrics).map(([key, value]) => (
                    <Box key={key} sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                      <Typography variant="caption" color="text.secondary">
                        {key}:
                      </Typography>
                      <Typography variant="caption" fontWeight={600}>
                        {value}
                      </Typography>
                    </Box>
                  ))}
                </Box>
              </Paper>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
}